/**
 * ROBOTIS cart quote generator — Shopify edition
 * Ported from BigCommerce templates/pages/cart.html
 */
(function () {
  var DEFAULT_WEBHOOK =
    'https://script.google.com/a/macros/robotis.com/s/AKfycbzMivnvrIn4zHgpgg6rj9EjJEwmbu7QWZxqf9jYHiQZWKuGruGy8FOAElqo1rJMbA8K/exec';

  function root() {
    return document.querySelector('[data-cart-quote-root]');
  }

  function getWebhookUrl() {
    var el = root();
    var fromData = el && el.getAttribute('data-webhook-url');
    if (fromData) return fromData;
    if (window.RobotisCartQuote && window.RobotisCartQuote.webhookUrl) {
      return window.RobotisCartQuote.webhookUrl;
    }
    return DEFAULT_WEBHOOK;
  }

  function money(cents, currency) {
    currency = currency || 'USD';
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat);
    }
    return currency + ' ' + (Number(cents) / 100).toFixed(2);
  }

  // Cart shipping rate API returns price as a dollar string (e.g. "15.00"), not cents.
  function parseShippingRatePrice(price) {
    return parseFloat(price) || 0;
  }

  function formatShippingPrice(dollars, currency) {
    return dollars > 0 ? money(dollars * 100, currency) : 'Free';
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function getInputs(el) {
    var area = el.closest('[data-cart-quote-root]') || root();
    return {
      customerName: area.querySelector('.quote-customer-name').value.trim(),
      customerEmail: area.querySelector('.quote-customer-email').value.trim(),
      customerCompany: area.querySelector('.quote-company-name').value.trim(),
      shippingAddress1: area.querySelector('.quote-shipping-address1').value.trim(),
      shippingAddress2: area.querySelector('.quote-shipping-address2').value.trim(),
      shippingCity: area.querySelector('.quote-shipping-city').value.trim(),
      shippingState: area.querySelector('.quote-shipping-state').value.trim(),
      shippingPostal: area.querySelector('.quote-shipping-postal').value.trim(),
      shippingCountry: (area.querySelector('.quote-shipping-country').value.trim() || 'US').toUpperCase(),
      shippingPhone: area.querySelector('.quote-shipping-phone').value.trim(),
    };
  }

  function setStatus(el, message, type) {
    var area = el.closest('[data-cart-quote-root]') || root();
    var node = area.querySelector('.quote-shipping-status');
    if (!node) return;
    node.textContent = message || '';
    node.classList.toggle('is-error', type === 'error');
    node.classList.toggle('is-success', type === 'success');
  }

  function hasMinimumShippingAddress(inputs) {
    return inputs.shippingAddress1 && inputs.shippingCity && inputs.shippingState && inputs.shippingPostal && inputs.shippingCountry;
  }

  function countryName(code) {
    var map = { US: 'United States', CA: 'Canada' };
    return map[code] || code;
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('Could not load cart.');
      return r.json();
    });
  }

  function shopifyCartToQuoteItems(cart) {
    return (cart.items || []).map(function (item) {
      return {
        sku: item.sku || '',
        name: item.product_title + (item.variant_title && item.variant_title !== 'Default Title' ? ' - ' + item.variant_title : ''),
        quantity: item.quantity,
        unitPrice: item.final_price / 100,
        lineTotal: item.final_line_price / 100,
        productId: String(item.product_id || ''),
        variantId: String(item.variant_id || ''),
        options: item.options_with_values || [],
      };
    });
  }

  function waitForShippingRates(attempt) {
    attempt = attempt || 0;
    return fetch('/cart/async_shipping_rates.json', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        if (data && data.shipping_rates && data.shipping_rates.length) {
          return data.shipping_rates;
        }
        if (attempt >= 8) return [];
        return new Promise(function (resolve) {
          setTimeout(function () {
            resolve(waitForShippingRates(attempt + 1));
          }, 500);
        });
      });
  }

  function calculateShippingRates(inputs) {
    var payload = {
      shipping_address: {
        address1: inputs.shippingAddress1,
        address2: inputs.shippingAddress2,
        city: inputs.shippingCity,
        province: inputs.shippingState,
        zip: inputs.shippingPostal,
        country: countryName(inputs.shippingCountry),
      },
    };

    return fetch('/cart/prepare_shipping_rates.json', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Shipping could not be calculated.');
        return waitForShippingRates();
      })
      .then(function (rates) {
        return (rates || []).map(function (rate) {
          return {
            id: rate.id || rate.name,
            method: rate.presentment_name || rate.name || 'Shipping',
            cost: parseShippingRatePrice(rate.price),
          };
        });
      });
  }

  function populateShippingSelect(button, options) {
    var area = button.closest('[data-cart-quote-root]') || root();
    var select = area.querySelector('.quote-shipping-method-select');
    select.innerHTML = '<option value="">Select shipping method</option>';
    options.forEach(function (option) {
      var node = document.createElement('option');
      node.value = option.id;
      node.textContent = option.method + ' - ' + formatShippingPrice(option.cost);
      node.setAttribute('data-method', option.method);
      node.setAttribute('data-cost', String(option.cost));
      select.appendChild(node);
    });
    select.disabled = !options.length;
    setStatus(button, options.length ? 'Shipping options loaded. Please select a method.' : 'No shipping options returned.', options.length ? 'success' : 'error');
  }

  function getSelectedShipping(button) {
    var area = button.closest('[data-cart-quote-root]') || root();
    var select = area.querySelector('.quote-shipping-method-select');
    var option = select.options[select.selectedIndex];
    if (!option || !option.value) return null;
    return {
      method: option.getAttribute('data-method') || option.textContent,
      amount: Number(option.getAttribute('data-cost') || 0),
      hasAmount: true,
      source: 'quote_shipping_selector',
      label: 'Estimated Shipping',
      displayText: formatShippingPrice(Number(option.getAttribute('data-cost') || 0)),
    };
  }

  function buildQuoteHtml(cart, quoteNumber, quoteDate, inputs, shippingInfo) {
    var items = shopifyCartToQuoteItems(cart);
    var shippingAmount = shippingInfo && shippingInfo.hasAmount ? shippingInfo.amount : 0;
    var quoteTotal = cart.total_price / 100 + shippingAmount;
    var shippingLabel =
      shippingInfo && shippingInfo.hasAmount
        ? formatShippingPrice(shippingAmount, cart.currency)
        : 'Not selected';

    var rows = items
      .map(function (item) {
        return [
          '<tr>',
          '<td>', escapeHtml(item.sku), '</td>',
          '<td><strong>', escapeHtml(item.name), '</strong></td>',
          '<td style="text-align:center;">', escapeHtml(item.quantity), '</td>',
          '<td style="text-align:right;">', money(item.unitPrice * 100, cart.currency), '</td>',
          '<td style="text-align:right;">', money(item.lineTotal * 100, cart.currency), '</td>',
          '</tr>',
        ].join('');
      })
      .join('');

    if (!rows) {
      rows = '<tr><td colspan="5" style="text-align:center;">No items found in cart.</td></tr>';
    }

    var addressLines = [
      escapeHtml(inputs.shippingAddress1),
      inputs.shippingAddress2 ? escapeHtml(inputs.shippingAddress2) : '',
      [
        escapeHtml(inputs.shippingCity),
        escapeHtml(inputs.shippingState),
        escapeHtml(inputs.shippingPostal),
      ].join(', '),
      escapeHtml(inputs.shippingCountry),
    ].filter(Boolean).join('<br>');

    return [
      '<!doctype html><html><head><meta charset="utf-8"><title>Quote ',
      escapeHtml(quoteNumber),
      '</title><style>',
      'body{font-family:Arial,sans-serif;padding:40px;color:#222}',
      'table{width:100%;border-collapse:collapse;margin-top:20px}',
      'th,td{border-bottom:1px solid #ddd;padding:10px;text-align:left}',
      'th{background:#f2f2f2}',
      '.summary{width:430px;margin-left:auto;margin-top:24px;border-top:2px solid #111;padding-top:12px}',
      '.summary-row{display:flex;justify-content:space-between;padding:7px 0}',
      '.summary-row.total{font-size:20px;font-weight:700}',
      '@media print{.print-actions{display:none}}',
      '</style></head><body><div class="quote-wrap">',
      '<div style="display:flex;justify-content:space-between;border-bottom:3px solid #111;padding-bottom:18px;margin-bottom:28px">',
      '<div><h1 style="margin:0">Sales Quote</h1>',
      '<p><strong>Quote #:</strong> ', escapeHtml(quoteNumber), '</p>',
      '<p><strong>Date:</strong> ', escapeHtml(quoteDate), '</p></div>',
      '<div style="text-align:right"><strong>ROBOTIS</strong><br>america@robotis.com<br>www.robotis.us</div>',
      '</div>',
      '<div style="display:grid;grid-template-columns:1fr 1fr;gap:18px;border:1px solid #ddd;padding:16px;margin-bottom:24px;background:#fafafa">',
      '<div><h3>Quote Contact</h3>',
      '<p><strong>Customer Name:</strong> ', escapeHtml(inputs.customerName || 'Not provided'), '</p>',
      '<p><strong>Customer Email:</strong> ', escapeHtml(inputs.customerEmail || 'Not provided'), '</p>',
      '<p><strong>Company:</strong> ', escapeHtml(inputs.customerCompany || 'Not provided'), '</p></div>',
      '<div><h3>Shipping Address</h3><p>', addressLines, '</p></div></div>',
      '<table><thead><tr><th>SKU</th><th>Product</th><th>Qty</th><th>Unit Price</th><th>Line Total</th></tr></thead><tbody>',
      rows,
      '</tbody></table>',
      '<div class="summary">',
      '<div class="summary-row"><span>Subtotal</span><strong>', money(cart.total_price, cart.currency), '</strong></div>',
      '<div class="summary-row"><span>Estimated Shipping</span><strong>', shippingLabel, '</strong></div>',
      '<div class="summary-row total"><span>Quote Total</span><strong>', money(quoteTotal * 100, cart.currency), '</strong></div>',
      '</div>',
      '<p style="margin-top:24px;color:#555;font-size:13px">Taxes may apply at checkout. This quote is for estimation purposes.</p>',
      '<div class="print-actions" style="margin-top:30px;text-align:right">',
      '<button type="button" onclick="window.print()">Print Quote</button></div>',
      '</div></body></html>',
    ].join('');
  }

  function sendQuoteRecord(cart, quoteNumber, quoteDate, inputs, shippingInfo, quoteTotal) {
    var WEBHOOK_URL = getWebhookUrl();
    if (!WEBHOOK_URL) return;

    var payload = JSON.stringify({
      quoteNumber: quoteNumber,
      quoteDateIso: quoteDate.toISOString(),
      quoteDateDisplay: quoteDate.toLocaleDateString(),
      cartId: cart.token || '',
      customerName: inputs.customerName,
      customerEmail: inputs.customerEmail,
      customerCompany: inputs.customerCompany,
      shippingAddress1: inputs.shippingAddress1,
      shippingAddress2: inputs.shippingAddress2,
      shippingCity: inputs.shippingCity,
      shippingState: inputs.shippingState,
      shippingPostal: inputs.shippingPostal,
      shippingCountry: inputs.shippingCountry,
      shippingPhone: inputs.shippingPhone,
      currencyCode: cart.currency || 'USD',
      cartTotalBeforeShipping: cart.total_price / 100,
      estimatedShippingMethod: shippingInfo ? shippingInfo.method : '',
      estimatedShippingCost: shippingInfo && shippingInfo.hasAmount ? shippingInfo.amount : '',
      quoteTotal: quoteTotal,
      shippingSource: shippingInfo ? shippingInfo.source : '',
      pageUrl: window.location.href,
      platform: 'shopify',
      items: shopifyCartToQuoteItems(cart),
    });

    try {
      if (navigator.sendBeacon) {
        var blob = new Blob([payload], { type: 'text/plain;charset=utf-8' });
        if (navigator.sendBeacon(WEBHOOK_URL, blob)) return;
      }
    } catch (e) {}

    fetch(WEBHOOK_URL, { method: 'POST', mode: 'no-cors', body: payload, keepalive: true }).catch(function () {});
  }

  function generateQuote(button) {
    var inputs = getInputs(button);
    fetchCart()
      .then(function (cart) {
        if (!cart.item_count) throw new Error('Your cart is empty.');
        var shippingInfo = getSelectedShipping(button);
        var quoteNumber = 'Q' + Date.now();
        var quoteDate = new Date();
        var quoteTotal = cart.total_price / 100 + (shippingInfo && shippingInfo.hasAmount ? shippingInfo.amount : 0);
        sendQuoteRecord(cart, quoteNumber, quoteDate, inputs, shippingInfo, quoteTotal);
        var html = buildQuoteHtml(cart, quoteNumber, quoteDate.toLocaleDateString(), inputs, shippingInfo);
        var win = window.open('', '_blank');
        if (!win) throw new Error('Please allow pop-ups to view the printable quote.');
        win.document.open();
        win.document.write(html);
        win.document.close();
      })
      .catch(function (err) {
        window.alert(err.message || 'Unable to generate quote.');
      });
  }

  function bind() {
    var area = root();
    if (!area || area.dataset.bound === 'true') return;
    area.dataset.bound = 'true';

    area.querySelector('.toggle-quote-box-btn').addEventListener('click', function () {
      var box = area.querySelector('.quote-info-box');
      var expanded = box.classList.toggle('quote-box-collapsed') === false;
      this.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      this.textContent = expanded ? 'Hide quote form' : 'Show quote form';
    });

    area.querySelector('.quote-load-shipping-options-btn').addEventListener('click', function () {
      var btn = this;
      var inputs = getInputs(btn);
      if (!hasMinimumShippingAddress(inputs)) {
        setStatus(btn, 'Please complete the shipping address before calculating rates.', 'error');
        return;
      }
      btn.disabled = true;
      btn.textContent = 'Calculating...';
      calculateShippingRates(inputs)
        .then(function (options) {
          populateShippingSelect(btn, options);
        })
        .catch(function (err) {
          setStatus(btn, err.message || 'Shipping could not be calculated.', 'error');
        })
        .finally(function () {
          btn.disabled = false;
          btn.textContent = 'Calculate Shipping Options';
        });
    });

    area.querySelector('.quote-shipping-method-select').addEventListener('change', function () {
      setStatus(this, this.value ? 'Selected: ' + this.options[this.selectedIndex].textContent : 'Please select a shipping method.', this.value ? 'success' : 'error');
    });

    area.querySelector('.generate-quote-btn').addEventListener('click', function () {
      generateQuote(this);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
